import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';

import { PortalAuthService } from './portal-auth.service';

// Gates every protected portal route: resolves the session (which also loads the
// org branding), then allows through only when a portal user is signed in —
// otherwise sends them to the login page, carrying the page they were after as
// ?redirect so signing in returns them there.
@Injectable({ providedIn: 'root' })
export class PortalAuthGuard implements CanActivate {

	constructor(private auth: PortalAuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		return this.auth.ensureSession().then(user => (user ? true : this.auth.loginUrlTree(state.url)));
	}
}
